function Komoju({ dimensions, col = '#000' }) {
    const baseXml = `
      <svg width=${dimensions || '24'} height=${dimensions || '24'} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="2" y="5" width="20" height="14" rx="2" stroke=${`"${col}"`} stroke-width="2"/>
        <path d="M8 8V16M8 12L13 8M13 16L10 13.5" stroke=${`"${col}"`} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <circle cx="17" cy="12" r="2" fill=${`"${col}"`}/>
      </svg>
    `;

    return baseXml;
}

export default Komoju;
